import { __assign, __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { Icon } from '../../primitives/icon/icon';
import { ellipsis, ellipsisVertical } from '../../icons/processed';
import { Tooltip } from '../../primitives/tooltip/tooltip';
import { Popover } from '../../primitives/popover/popover';
import * as classNames from 'classnames';
import { MenuItemContext } from '../floater-menu/floater-menu';
export var ActionsMenuButtonKey = 'actions-menu-button';
var ActionsMenuButton = /** @class */ (function (_super) {
    __extends(ActionsMenuButton, _super);
    function ActionsMenuButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isOpen: _this.props.controlled ? _this.props.controlled.isOpen : false
        };
        _this.onCloseMenu = function () { return _this.setState({ isOpen: false }); };
        _this.onOpenMenu = function () {
            var _a = _this.props, disabled = _a.disabled, controlled = _a.controlled;
            if (!disabled && controlled === undefined) {
                _this.setState({ isOpen: true });
            }
        };
        _this.onControlledOpenMenu = function (e) {
            if (_this.props.controlled) {
                _this.props.controlled.onOpenMenu(e);
            }
        };
        return _this;
    }
    ActionsMenuButton.prototype.render = function () {
        var _a = this, state = _a.state, props = _a.props;
        var preferPlace = props.preferPlace;
        var bringToFront = props.bringToFront;
        var compClassNames = namespacedClassnames(ActionsMenuButtonKey, props.className);
        var closeOnInnerAction = props.closeOnInnerAction !== undefined ? props.closeOnInnerAction : true;
        var controlled = props.controlled;
        var maybeOnClick = closeOnInnerAction && controlled === undefined ? {
            onClick: this.onCloseMenu
        } : {};
        var isOpen = controlled ? controlled.isOpen : state.isOpen;
        var onOuterAction = controlled ? controlled.onOuterAction : this.onCloseMenu;
        var body = (React.createElement("div", __assign({ className: 'actions-menu-body' }, maybeOnClick),
            React.createElement(MenuItemContext.Provider, { value: { allowPropagation: true } }, props.children)));
        var icon = (props.horizontal) ? React.createElement(Icon, { icon: ellipsis }) : React.createElement(Icon, { icon: ellipsisVertical });
        var btnClassNames = classNames('actions-button', {
            disabled: !!props.disabled,
            active: isOpen,
            'no-change-color-active': props.noHighlightWhenOpen,
            horizontal: props.horizontal,
            vertical: !props.horizontal,
            borderless: props.borderless
        });
        var buttonComp = (React.createElement(Popover, { body: body, isOpen: isOpen, bringToFront: bringToFront, onOuterAction: onOuterAction, preferPlace: preferPlace },
            React.createElement("button", { className: btnClassNames, onClick: controlled ? this.onControlledOpenMenu : this.onOpenMenu, disabled: !!props.disabled }, icon)));
        return !!props.disabled ? (React.createElement("div", { className: compClassNames },
            React.createElement(Tooltip, { body: props.disabled, relativeToBody: true }, buttonComp))) : (React.createElement("div", { className: compClassNames }, buttonComp));
    };
    return ActionsMenuButton;
}(React.PureComponent));
export { ActionsMenuButton };
//# sourceMappingURL=index.js.map